// Generated by scripts/generate-public-surface.ts. Do not edit.

import type {
  CountryValidator,
  ParsedPersonId,
} from "../../types";

import { createValidator } from "#stdnum-runtime";

const curp: CountryValidator<"MX", ParsedPersonId> =
  createValidator("mx.curp", 129);

export default curp;
export const compact = curp.compact;
export const format = curp.format;
export const validate = curp.validate;
export const generate = (): string =>
  curp.generate?.() ??
  (() => {
    throw new Error(
      "Validator mx.curp cannot generate values",
    );
  })();
export const parse = curp.parse;
